
export default function Select({ value, options, setValues,id }) {
    
  return (
    <div>
      <select
        className="form-control"
        // disabled={colorShow?"":"disabled"}
        id="val-skill"
        name="val-skill"
        value={value}
        onChange={(event) => {
          setValues(event.target.value);
        }}
      >
          <option></option>
        {options.map((val) => {
           
          return (
              <>
                 {id==="color"?(
                   <option value={val.name}>{val.name}</option>
                  
                 ):(  
                    <option value={val}>{val}</option>
                 )}
              </>
          );
        })}
      </select>
    </div>
  );
}
